import { useEffect } from 'react';
import { getVegaOsApi } from 'utils/vegaos/VegaOsApi';
import { APP_VERSION } from 'version';
import { useAppContext } from '../context/app-context';
import { Device, DeviceSubtype, getDevice, getDeviceSubtype } from '../utils/getDevice';
import monitor from '../utils/monitor';

const device = getDevice();
export const useNewRelicData = () => {
  const { webosDeviceInfo } = useAppContext();

  useEffect(() => {
    monitor.setReleaseVersion(APP_VERSION.version);
  }, []);

  useEffect(() => {
    if (device === Device.lgtv && webosDeviceInfo) {
      monitor.addPersistentAttributes('webosVersion', webosDeviceInfo.sdkVersion);
      monitor.addPersistentAttributes('modelName', webosDeviceInfo.modelName);
    }
  }, [webosDeviceInfo]);

  useEffect(() => {
    if (device === Device.androidtv || device === Device.firetv) {
      if (getDeviceSubtype() === DeviceSubtype.none && window && self.Android && monitor) {
        monitor.addPersistentAttributes('modelName', self.Android.getModelName());
        monitor.addPersistentAttributes('apiLevel', self.Android.getApiLevel());
      } else if (getDeviceSubtype() === DeviceSubtype.vegaos && window && self.ReactNativeWebView && monitor) {
        monitor.addPersistentAttributes('modelName', getVegaOsApi()?.getBuildInfo?.()?.model);
        monitor.addPersistentAttributes('apiLevel', getVegaOsApi()?.getBuildInfo?.()?.systemVersion);
      }
    }
  }, []);

  useEffect(() => {
    if (device === Device.xbox) {
      if (window?.UWP) {
        monitor.addPersistentAttributes('modelName', self.UWP.model);
        monitor.addPersistentAttributes('modelVersion', self.UWP.modelVersion);
      }
    }
  }, []);
};
